import type { ToolResult } from "@/types/tools";

export type UtmInput = {
  url: string;
  source?: string;
  medium?: string;
  campaign?: string;
  term?: string;
  content?: string;
};

const utmFields: Array<[keyof UtmInput, string]> = [
  ["source", "utm_source"],
  ["medium", "utm_medium"],
  ["campaign", "utm_campaign"],
  ["term", "utm_term"],
  ["content", "utm_content"],
];

export function buildUtmUrl(input: UtmInput): ToolResult<string> {
  try {
    const url = new URL(input.url.trim());

    for (const [field, parameter] of utmFields) {
      const value = input[field];

      if (typeof value === "string" && value.trim()) {
        url.searchParams.set(parameter, value.trim());
      }
    }

    return {
      ok: true,
      value: url.toString(),
    };
  } catch {
    return {
      ok: false,
      error: "Enter a valid absolute URL, such as https://example.com/page.",
    };
  }
}
